import React, {useState} from 'react';
import { AppBar, Toolbar, Typography, Box, Link, IconButton, SwipeableDrawer } from '@mui/material';
import { useAuthContext } from "../../hooks/useContext/useAuthContext";
import CartIconButton from "./CartIconButton";
import MenuIcon from '@mui/icons-material/Menu';
import DrawerContent from "./DrawerContent";
import Logo from "../Shared/Logo";
import { useTheme } from '@mui/material/styles';



export default function Navbar() {
  const { user } = useAuthContext();
  const [hamburgerMenuOpen, setHamburgerMenuOpen] = useState(false);
  const theme = useTheme();


  // const toggleDrawer = (open) => (event) => {
  //   if (
  //     event.type === 'keydown' &&
  //     (event.key === 'Tab' || event.key === 'Shift')
  //   ) {
  //     return;
  //   }
  //   setHamburgerMenuOpen(open);
  // };

  const toggleDrawer = (open) => {
    setHamburgerMenuOpen(open);
  };

  return (
    <AppBar
      position="sticky"
      // color={theme.palette.common.white}
      elevation={1}
      sx={{
        backgroundColor: theme.palette.common.white,
      }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>

        <Box sx={{ display: { xs: 'none', md: 'none', lg: 'flex' } }}>
          <Logo logoHeight={'36px'} />
        </Box>

        <Box sx={{ display: { xs: 'flex', md: 'flex', lg: 'none' } }}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ 
              display: { xs: 'block', md: 'block', lg: 'none' },
              borderRadius: '50%', //circular shape
              padding: '10px',
              width: '48px',
              height: '48px', // Set sameas width to maintain circle shape
            }}
            onClick={() => toggleDrawer(true)}
          >
            <MenuIcon sx={{ color: '#8f8f8f' }} />
          </IconButton>
          <SwipeableDrawer
            anchor='bottom'
            open={hamburgerMenuOpen}
            onClose={() => toggleDrawer(false)}
            onOpen={() => toggleDrawer(true)}
            disableSwipeToOpen={true}
            hysteresis={0.8}
            sx={{
              '& .MuiDrawer-paper': {
                marginTop: '64px',
                height: `calc(100% - 64px)`,
                background: 'transparent',
                backgroundImage: 'linear-gradient(to bottom, transparent 50%, #ecedf1 50%)'
              },
            }}
          >
            <DrawerContent user={user} toggleDrawer={toggleDrawer} theme={theme} />
          </SwipeableDrawer>
        </Box>

{/* about /order /location buttons in desktop view */}
        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'none', lg: 'flex' }, justifyContent: 'flex-end', alignItems: 'center' }}>

          <Link href="/" color="inherit" sx={{ p: 1, textDecoration: 'none', mr: 3 }}>
            <Typography
              sx={{
                color: theme.palette.common.offBlack,
                backgroundColor: 'transparent',
                ":hover": { color: theme.palette.primary.main, bgcolor: theme.palette.common.white },
              }}
            >
              Strona Główna
            </Typography>
          </Link>
          <Link href="/order" sx={{ p: 1, textDecoration: 'none', mr: 3 }}>
            <Typography
                sx={{
                  color: theme.palette.common.offBlack,
                  backgroundColor: 'transparent',
                  ":hover": { color: theme.palette.primary.main, bgcolor: theme.palette.common.white },
                }}
              >
              Zamówienie
            </Typography>
          </Link>
          <Link href="/about" color="inherit" sx={{ p: 1, textDecoration: 'none', mr: 3 }}>
            <Typography
              sx={{
                color: theme.palette.common.offBlack,
                backgroundColor: 'transparent',
                ":hover": { color: theme.palette.primary.main, bgcolor: theme.palette.common.white },
              }}
            >
              Informacje
            </Typography>
          </Link>
          <Link href="/location" sx={{ p: 1, textDecoration: 'none', mr: 3 }}>
            <Typography
                sx={{
                  color: theme.palette.common.offBlack,
                  backgroundColor: 'transparent',
                  ":hover": { color: theme.palette.primary.main, bgcolor: theme.palette.common.white },
                }}
              >
              Lokalizacja
            </Typography>
          </Link>
        </Box>

{/* dashboard / Your car buttons */}
        <Box sx={{ display: { xs: 'flex', md: 'flex', lg: 'flex' } }}>
          <CartIconButton />
        </Box>

      </Toolbar>
    </AppBar>
  );
}